import React from 'react';

interface SkeletonProps extends React.HTMLAttributes<HTMLDivElement> {
    /** Clases de tamaño (h-*, w-*) que dibujan la silueta del contenido real */
    className?: string;
}

/**
 * Skeleton — Sistema 2.0.
 * Reemplaza spinners en listas/tablas/tarjetas: dibuja la FORMA del contenido
 * mientras carga (acero-100 con shimmer). Composición libre:
 *
 *   <Skeleton className="h-4 w-2/3" />
 *   <SkeletonText lines={3} />
 *   <SkeletonCard />          — tarjeta genérica
 *   <SkeletonRows rows={5} /> — filas de tabla/lista
 */
export const Skeleton: React.FC<SkeletonProps> = ({ className = '', ...props }) => (
    <div aria-hidden="true" className={`skeleton ${className}`} {...props} />
);

export const SkeletonText: React.FC<{ lines?: number; className?: string }> = ({ lines = 3, className = '' }) => (
    <div className={`flex flex-col gap-2 ${className}`} aria-hidden="true">
        {Array.from({ length: lines }).map((_, i) => (
            <Skeleton key={i} className={`h-3.5 ${i === lines - 1 ? 'w-3/5' : 'w-full'}`} />
        ))}
    </div>
);

export const SkeletonCard: React.FC<{ className?: string }> = ({ className = '' }) => (
    <div className={`rounded-2xl border border-acero-200 bg-white p-5 ${className}`} aria-hidden="true">
        <div className="flex items-center gap-3 mb-4">
            <Skeleton className="h-10 w-10 rounded-xl" />
            <div className="flex-1 flex flex-col gap-2">
                <Skeleton className="h-3.5 w-1/2" />
                <Skeleton className="h-3 w-1/3" />
            </div>
        </div>
        <SkeletonText lines={2} />
    </div>
);

export const SkeletonRows: React.FC<{ rows?: number; className?: string }> = ({ rows = 5, className = '' }) => (
    <div className={`flex flex-col gap-3 ${className}`} aria-hidden="true">
        {Array.from({ length: rows }).map((_, i) => (
            <div key={i} className="flex items-center gap-3">
                <Skeleton className="h-8 w-8 rounded-lg shrink-0" />
                <Skeleton className="h-3.5 flex-1" />
                <Skeleton className="h-3.5 w-16 shrink-0" />
            </div>
        ))}
    </div>
);
